import React from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

// Import styles
import "./styles/products.scss";

// Import bootstrap
import { Button, Card, Col } from "react-bootstrap";

const Canvases = () => {
  const data = useStaticQuery(graphql`
    {
      allShopifyCollection(filter: { title: { eq: "Canvases" } }) {
        nodes {
          products {
            handle
            id
            images {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            priceRange {
              minVariantPrice {
                amount
              }
            }
            title
          }
        }
      }
    }
  `);

  const { allShopifyCollection } = data;

  return (
    <>
      {allShopifyCollection.nodes.map(({ products }) => {
        return products.map((product) => {
          let price = parseInt(
            product.priceRange.minVariantPrice.amount.split(".0")
          );
          let num = parseFloat(price);
          let salePrice = num - num * 0.2;
          salePrice = Math.round(salePrice);
          return (
            <Col className="product" xs={12} md={6} lg={4} key={product.id}>
              <Card>
                {product.images.map((image) => {
                  return (
                    <GatsbyImage
                      image={image.localFile.childImageSharp.gatsbyImageData}
                      alt="test"
                    />
                  );
                })}
                <Card.Body>
                  <h3 className="declare">
                    <span className="old-price">${price}</span> ${salePrice}
                  </h3>
                  <h4 className="shout">{product.title}</h4>
                  <Link to={`products/${product.handle}`}>
                    <Button variant="primary">View Product</Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          );
        });
      })}
    </>
  );
};

export default Canvases;
